import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";

import { useNavigate, useSearch } from "@tanstack/react-router";
import { useDeleteProduct, useProductsQuery } from "../api/queries";
import { ProductsFilter } from "../ui/ProductsFilter";
import { ProductsTable } from "../ui/ProductsTable";
import { ProductsToolbar } from "../ui/ProductsToolbar";

export function ProductsPage() {
  const nav = useNavigate({ from: "/app/catalog/products" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/catalog/products",
  });

  const list = useProductsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["catalog:create"]);
  const deleteProduct = useDeleteProduct();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ສິນຄ້າ / ເມນູ",
              to: "/app/catalog/products",
            },
          ]}
        />
      </Header>
      <Main>
        <ProductsToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/catalog/products/create" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ProductsFilter />

          <ProductsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(row) =>
              nav({
                to: "/app/catalog/products/$id/edit",
                params: { id: row.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteProduct.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບສິນຄ້າສຳເລັດ",
                error: "ລຶບສິນຄ້າລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
